import { Typography } from '@mui/material';
import React from 'react';

export const Pill = (props: { bgColor?: string, color?: string, children: React.ReactNode; }) => {
    return <Typography component='span' sx={{ borderRadius: 1, fontSize: '0.9em', p: 0.2, margin: '0 0.2em', backgroundColor: props.bgColor ?? '#CCC', color: props.color ?? '#FFF' }}>{props.children}</Typography>;
};
